import { createGlobalStyle } from 'styled-components'

import fonts from 'assets/fonts'

import media from 'utils/media'

const GlobalStyles = createGlobalStyle`
   @font-face {
      font-family: 'Portrait';
      src: url(${fonts.PortraitBoldTrial}) format('woff2');
      font-weight: 700;
      font-style: normal;
   }

   @font-face {
      font-family: 'Portrait';
      src: url(${fonts.PortraitMediumTrial}) format('woff2');
      font-weight: 500;
      font-style: normal;
   }

   @font-face {
      font-family: 'Portrait';
      src: url(${fonts.PortraitLightTrial}) format('woff2');
      font-weight: 300;
      font-style: normal;
   }

   @font-face {
      font-family: 'Portrait';
      src: url(${fonts.PortraitRegularTrial}) format('woff2');
      font-weight: 400;
      font-style: normal;
   }

   @font-face {
      font-family: 'Portrait';
      src: url(${fonts.PortraitRegular2Trial}) format('woff2');
      font-weight: 450;
      font-style: normal;
   }

   @font-face {
      font-family: 'Sohne';
      src: url(${fonts.TestSohneLight}) format('woff2');
      font-weight: 300;
      font-style: normal;
   }

   @font-face {
      font-family: 'Sohne';
      src: url(${fonts.TestSohneRegular}) format('woff2');
      font-weight: 400;
      font-style: normal;
   }

   @font-face {
      font-family: 'Sohne';
      src: url(${fonts.TestSohneSemiBold}) format('woff2');
      font-weight: 600;
      font-style: normal;
   }

   @font-face {
      font-family: 'Sohne';
      src: url(${fonts.TestSohneBold}) format('woff2');
      font-weight: 700;
      font-style: normal;
   }

   @font-face {
      font-family: 'Arial';
      src: url(${fonts.ArialBoldMT}) format('woff2');
      font-weight: 700;
      font-style: normal;
   }

  html {
    text-rendering: optimizeLegibility;
    font-feature-settings: "kern" 1;
    font-kerning: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  body {
    word-break: break-word;
  }

  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  h2 {
    color: ${({ theme }) => theme.colors.header};
  }

  a {
    text-decoration: none;
    color: inherit;
    cursor: pointer;
  }

  button {
    outline: none;
    appearance: button;
    color: inherit;
  }

  ul {
    list-style: none;
    margin: 0;
  }

  /*Global rules for HTML classNames */
  .swiper-pagination {
    bottom: 0 !important;
    line-height: 1;

    span {
      width: 12px;
      height: 12px;
      background: ${({ theme }) => theme.colors.sliderBulletBg};

      &.swiper-pagination-bullet-active {
        background: ${({ theme }) => theme.colors.sliderBulletActiveBg};
      }
    }
  }

  .rc-tooltip {
    max-width: 250px;
    opacity: 1;

    ${media.greaterThan('sm')`
      max-width: 350px;
    `};

    .rc-tooltip-inner {
      padding: 15px;
      font-size: 14px;
      background: #edeef0;
      box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.5);
      color: ${({ theme }) => theme.colors.textColor};

      ${media.greaterThan('md')`
        font-size: 16px;
      `};
    }

    .rc-tooltip-arrow {
      width: 15px;
      height: 15px;
      background: #edeef0;
      transform: translateY(-50%) rotate(45deg);
      bottom: -5px;
      border:none;
    }

    &.rc-tooltip-placement-topLeft .rc-tooltip-arrow {
      left: 40px;
    }
    &.rc-tooltip-placement-topRight .rc-tooltip-arrow {
      right: 40px;
    }
  }

  .no-js-visibility {
    opacity: 0;
  }

  .clear {
    clear: both;
  }

  .mobile {
      ${media.greaterThan('md')`
         display: none;
      `};
   }

   .tablet {
      display: none;

      ${media.between('md', 'lg')`
         display: block;
      `};
   }

   .desktop {
      display: none;

      ${media.greaterThan('lg')`
         display: block;
      `};

      &.tablet {
         ${media.greaterThan('md')`
            display: block;
         `};
      }
   }

   .btn {
      display: inline-flex;
      align-items: center;
      padding: 16px 36px;
      margin: 0;
      border: ${({ theme }) =>
         theme.darkMode ? `2px solid ${theme.colors.grey_3}` : `2px solid ${theme.colors.hotCinnamon}`};
      background-color: ${({ theme }) => (theme.darkMode ? theme.colors.grey_6 : theme.colors.white)};
      color: ${({ theme }) => (theme.darkMode ? theme.colors.grey_3 : theme.colors.hotCinnamon)};
      font-size: 18px;
      line-height: 27px;
      font-weight: 700;
      cursor: pointer;
      transition: 0.3s cubic-bezier(0, 0.89, 0.44, 1);
      text-align: center;

      svg {
         display: inline-block;
         margin-right: ${({ small }) => (small ? '11px' : '19px')};
      }

      img {
         margin: 0;
      }

      &:hover {
         background-color: ${({ theme }) => theme.colors.hotCinnamon};
         color: ${({ theme }) => theme.colors.white};
         border: ${({ theme }) => `2px solid ${theme.colors.hotCinnamon}`};
      }

      &:disabled {
         background-color: ${({ theme }) => theme.colors.grey};
         border: ${({ theme }) => `2px solid ${theme.colors.grey}`};
         cursor: not-allowed;
         color: ${({ theme }) => theme.colors.grey_3};
         box-shadow: none;
      }

      &.small {
         padding: 8px 24px;
      }

      &.outline {
         border: ${({ theme }) =>
            theme.darkMode ? `2px solid ${theme.colors.grey_3}` : `2px solid ${theme.colors.textColor}`};
         color: ${({ theme }) => (theme.darkMode ? theme.colors.grey_3 : theme.colors.textColor)};

         &:hover {
            color: ${({ theme }) => theme.colors.white};
            border: ${({ theme }) => `2px solid ${theme.colors.hotCinnamon}`};
         }
      }
   }

   @keyframes fadeIn {
      0% { opacity: 1; }
      100% { opacity: 0; }
   }
   @keyframes fadeOut {
      0% { opacity: 0; }
      100% { opacity: 1; }
   }
`

export default GlobalStyles
